module.exports = __webpack_public_path__ + "img/tourial-trip-m.62b9dcde.png";